import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { getSVG } from './../../helpers/util'
import SVG from './../SVG'

import './Checkbox.scss'
import { isEmpty } from 'lodash'

const tickIcon = getSVG('tick')

const Checkbox = ({
  onChange,
  checked,
  className,
  children,
  name,
  disabled,
  tabIndex,
  autoFocus,
  id,
  errorMsg,
  isSubmitted,
  isRequired
}) => {
  const inputId = id || name
  const labelId = inputId ? `${inputId}-label` : undefined
  const [isChecked, setValue] = useState(checked)
  const isMounted = useRef(false)
  const isValid = isSubmitted && isRequired && !isChecked
  const changeHandler = event => {
    !disabled && isMounted.current && setValue(event.target.checked)
    !disabled &&
      isMounted.current &&
      onChange({
        target: {
          value: event.target.checked,
          name,
          id
        }
      })
  }

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (isChecked !== checked) {
      isMounted.current && setValue(checked)
    }
  }, [isChecked, checked])

  const checkedClass = isChecked ? 'checked' : ''
  return (
    <>
      <span // eslint-disable-line
        className={
          `checkbox ${className} ${checkedClass}` + (isValid ? 'is-error' : '')
        }
        onClick={event => {
          if (event.target.type !== 'checkbox') {
            changeHandler({ target: { checked: !isChecked } })
          }
        }}
      >
        <input
          id={inputId}
          aria-labelledby={labelId}
          name={name}
          disabled={disabled}
          tabIndex={tabIndex}
          autoFocus={autoFocus} // eslint-disable-line
          type="checkbox"
          checked={isChecked}
          onChange={changeHandler}
        />
        <label className="label" id={labelId}>
          {children} {isRequired && ' *'}
        </label>
        <span className="tick">
          <SVG>{tickIcon}</SVG>
        </span>
        <div className="error">
          {isValid &&
            (isEmpty(errorMsg) ? (
              <span>Please enter {name}.</span>
            ) : (
              <span>{errorMsg}</span>
            ))}
        </div>
      </span>
    </>
  )
}

Checkbox.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  name: PropTypes.string,
  tabIndex: PropTypes.number,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  id: PropTypes.string
}

Checkbox.defaultProps = {
  onChange: () => {},
  checked: false,
  className: '',
  name: '',
  tabIndex: 0,
  disabled: false,
  autoFocus: false
}

export default Checkbox
